export const ipChangeSettings = ()=> {
  if (window.location.href.indexOf(".lvmh-pc.lvmh") != -1){
    //截取请求后缀
    const ipSuffix = process.env.BASE_URL.split(process.env.DOMAIN)[1];
    //返回域登录内网访问地址
    return `${process.env.AD_DOMAIN}${ipSuffix}`; //process.env.AD_DOMAIN + '/api/web';
  }
  return `${process.env.BASE_URL}`;
}



// WEBPACK FOOTER //
// ./src/utils/ipChangeSettings.js